import React, { useEffect, useState } from "react";
import { Modal, Spinner } from "react-bootstrap";
import Table from "./Table";
import "../Assets/Css/Department.scss";
import "../Assets/Css/ActiveTaskModal.scss";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import moment from "moment";

function ActiveTaskModal({ isModalVisible, closeModal, taskList, loading }) {
  const navigate = useNavigate();
  const [activeTasks, setActiveTasks] = useState([]);
  
  useEffect(() => {
    if (isModalVisible && taskList && taskList.length > 0) {
      const tableData = taskList.map((item, idx) => ({
        "Sr No": { value: idx + 1, type: "text" },
        "Task": { value: item.title || "Untitled", type: "text" },
        "Employee": {
          value: item.taskTimerMap?.[0]?.user?.name || "Unknown Employee",
          type: "text"
        },
        "Start Time": {
           value: item.taskTimerMap?.[0]?.start_time
            ? moment(item.taskTimerMap[0].start_time).format('DD-MM-YYYY hh:mm a')
            : "Not Started",
          type: "text"
        },
        taskId: item.id,
        rawData: item,
        clickable: true
      }));

      setActiveTasks(tableData);
    } else {
      setActiveTasks([]);
    }
  }, [isModalVisible, taskList]);
  
  const handleRowClick = (rowData) => {
    navigate(`/task/emptask/view/${rowData.taskId}`);
    closeModal(); 
  };

  const header = [
    { field: "Sr No" },
    { field: "Task" },
    { field: "Employee" },
    { field: "Start Time" }
  ];
  const handleModalClose = () => {
    closeModal();
  };

  return (
    <Modal
      show={isModalVisible}
      onHide={handleModalClose}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="custom-modal"
    >
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="heading">Active Tasks</h5>
          <button className="btn-close" onClick={closeModal}></button>
        </div>
        <div className="modal-body">
          <div className="add-department-container">
            <div className="add-information-part">
              {loading ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    padding: "20px",
                  }}
                >
                  <Spinner
                    as="span"
                    animation="border"
                    role="status"
                    aria-hidden="true"
                  />
                </div>
              ) : (
                <Table
                  header={header}
                  data={activeTasks}
                  footer={false}
                  count={activeTasks.length}
                  records={activeTasks.length}
                  loading={loading}
                  showIsView={false}
                  showIsDelete={false}
                  showIsEdit={false}
                  rowClickType="navigate"
                  onRowClick={handleRowClick}
                />
              )}
            </div>
          </div>
        </div>
        <div className="modal-footer d-flex justify-content-start">
          <button className="btn-cancel" onClick={closeModal}>
            Close
          </button>
        </div>
      </div>
    </Modal>
  );
}

export default ActiveTaskModal;
